/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RegistrationPeriod {
  ONE_YEAR = 'one_year',
  TWO_YEARS = 'two_years',
  SEVEN_DAYS = 'seven_days',
  NINETY_DAYS = 'ninety_days',
}
